/**
 * [API Docs] https://api.platform.cresclab.com/api/docs#tag/Product-Feed
 */
import { makeApi } from "@zodios/core";
import { z } from "zod";

import {
  ProductFeedCreateRequestSchema,
  ProductFeedListResponseSchema,
  ProductFeedSchema,
  ProductFeedUpdateRequestSchema,
  SignedUrlRequestSchema,
  SignedUrlResponseSchema,
} from "../models";

const api = makeApi([
  {
    alias: "generateSignedUrl",
    method: "post",
    path: "/api/v1/product-feeds/file-upload/generate-signed-url",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: SignedUrlRequestSchema,
      },
    ],
    response: SignedUrlResponseSchema,
  },
  {
    alias: "listFeeds",
    method: "get",
    path: "/api/v1/product-feeds/",
    response: ProductFeedListResponseSchema,
  },
  {
    alias: "createFeed",
    method: "post",
    path: "/api/v1/product-feeds/",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: ProductFeedCreateRequestSchema,
      },
    ],
    response: ProductFeedSchema,
  },
  {
    alias: "getFeed",
    method: "get",
    path: "/api/v1/product-feeds/:feedId",
    parameters: [
      {
        type: "Path",
        name: "feedId",
        schema: ProductFeedSchema.shape.id,
      },
    ],
    response: ProductFeedSchema,
  },
  {
    alias: "updateFeed",
    method: "put",
    path: "/api/v1/product-feeds/:feedId",
    parameters: [
      {
        type: "Path",
        name: "feedId",
        schema: ProductFeedSchema.shape.id,
      },
      {
        type: "Body",
        name: "body",
        schema: ProductFeedUpdateRequestSchema,
      },
    ],
    response: ProductFeedSchema,
  },
  {
    alias: "deleteFeed",
    method: "delete",
    path: "/api/v1/product-feeds/:feedId",
    parameters: [
      {
        type: "Path",
        name: "feedId",
        schema: ProductFeedSchema.shape.id,
      },
    ],
    // 204 No Content with z.void() or z.never() not working here
    response: z.unknown(),
  },
]);

export { api };
